export default __webpack_public_path__ + "static/media/message-bubble.e699a478.svg";